<template>
  <div class="modal-content">
    <h1 class="text-center">{{header}}</h1>
    <div class="columns is-multiline">
      <!-- project name -->
      <div class="column is-12">
        <label class="label" for="name">{{$t('modal-project.modalNewProjectName')}}<span class="required">*</span></label>
        <div class="control">
          <input type="text" id="name" :class="{'error-input': errorProjectName}" class="input" ref="projectName" v-model="projectName">
          <span v-if="errorProjectName" style="vertical-align: -4px; color: red;">{{errorInputMessage}}</span>
        </div>
      </div>
      <!-- customer -->
      <div class="column is-12">
        <label class="label" for="customer">{{$t('modal-project.modalLoadedProjectCustomer')}}<span class="required">*</span></label>
        <div class="control">
          <input type="text" id="customer" :class="{'error-input': errorProjectCustomer}" class="input" v-model="projectCustomer">
          <span v-if="errorProjectCustomer" style="vertical-align: -4px; color: red;">{{errorInputMessage}}</span>
        </div>
      </div>
      <!-- responsible -->
      <div class="column is-12">
        <label class="label" for="responsible">{{$t('modal-project.modalLoadedProjectResponsible')}}<span class="required">*</span></label>
        <div class="control">
          <input type="text" id="responsible" :class="{'error-input': errorProjectResponsible}" class="input" v-model="projectResponsible">
          <span v-if="errorProjectResponsible" style="vertical-align: -4px; color: red;">{{errorInputMessage}}</span>
        </div>
      </div>
      <!-- profile -->
      <!-- <div class="column is-12">
        <label class="label" for="profile">{{$t('profile.profile')}}<span class="required">*</span></label>
        <div class="control">
          <select v-model="selectedProfile" :class="{'error-input': errorProjectProfile}">
            <option v-if="profiles.length === 0" value="0" disabled="disabled">{{$t('profile.noProfileTypes')}}</option>
            <option v-if="profiles.length > 0" value="0" disabled="disabled">{{$t('profile.chooseProfile')}}</option>
            <option v-for="profile in profiles" :key="profile.profileId" :selected="profile.profileId" :value="profile.profileId">
              {{profile.name}}
            </option>
          </select>
          <span v-if="errorProjectResponsible" style="vertical-align: -4px; color: red;">{{errorInputMessage}}</span>
        </div>
      </div> -->
      <!-- description -->
      <div class="column is-12">
        <label class="label" for="description">{{$t('modal-project.modalNewProjectDescription')}}</label>
        <div class="control">
          <textarea id="description" class="textarea" v-model="projectDescription"></textarea>
        </div>
      </div>
    </div>
    <div class="text-center buttons-modal">
      <a @click="handleProject()" class="button primary">{{data ? $t('global.update') : $t('modal-project.modalButtonlabelNew')}}</a>
      <a @click="closeModal()" class="button">{{$t('global.cancel')}}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-project-modal',
  props: {
    data: {
      type: [Object, Array, String, Number, Boolean],
      required: false
    }
  },
  data () {
    return {
      projectName: this.data ? this.data.contentJson.name : '',
      projectCustomer: this.data ? this.data.contentJson.customer : '',
      projectResponsible: this.data ? this.data.contentJson.responsible : '',
      projectDescription: this.data ? this.data.contentJson.description : '',
      errorProjectName: false,
      errorProjectCustomer: false,
      errorProjectResponsible: false,
      // errorProjectProfile: false,
      errorInputMessage: '',
      tempProjectName: null,
      selectedProfile: 0
    }
  },
  computed: {
    ...mapGetters({
      profiles: 'getProfiles',
      project: 'getProject'
    }),
    header () {
      if (this.data) {
        return this.$t('modal-project.modalProjectEditExisting')
      } else {
        return this.$t('modal-project.modalProjectCreateNew')
      }
    }
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      setProfile: 'setProfile',
      setNewProject: 'setNewProject',
      updateProject: 'updateProject',
      setActivePageCode: 'setActivePageCode',
      validateProjectName: 'validateProjectName'
    }),
    async handleProject () {
      let responseValidatedName = true
      let doValidateName = true
      let validInputs = true

      this.errorProjectName = false
      this.errorProjectCustomer = false
      this.errorProjectResponsible = false
      // this.errorProjectProfile = false

      if (this.projectName.trim() === '') {
        validInputs = false
        this.errorProjectName = true
        this.errorInputMessage = this.$t('modal-project.modalNewProjectErrorInputMissing')
      }

      if (this.projectCustomer.trim() === '') {
        validInputs = false
        this.errorProjectCustomer = true
        this.errorInputMessage = this.$t('modal-project.modalNewProjectErrorInputMissing')
      }

      if (this.projectResponsible.trim() === '') {
        validInputs = false
        this.errorProjectResponsible = true
        this.errorInputMessage = this.$t('modal-project.modalNewProjectErrorInputMissing')
      }

      // if (this.selectedProfile === 0) {
      //   validInputs = false
      //   this.errorProjectProfile = true
      //   this.errorInputMessage = this.$t('modal-project.modalNewProjectErrorInputMissing')
      // }

      if (validInputs) {
        // existing project - edit
        if (this.data) {
          doValidateName = this.tempProjectName !== this.projectName
        }

        if (doValidateName) {
          try {
            responseValidatedName = await this.validateProjectName(this.projectName)
            if (!responseValidatedName) {
              this.errorProjectName = true
              this.errorInputMessage = this.$t('modal-project.modalNewProjectErrorProjectName')
            }
          } catch (err) {
            console.log('error validating project name', err)
          }
        }

        if (responseValidatedName) {
          if (this.data) {
            try {
              let projectObject = {
                name: this.projectName,
                customer: this.projectCustomer,
                responsible: this.projectResponsible,
                description: this.projectDescription
              }
              await this.updateProject(projectObject)
              this.closeModal()
            } catch (err) {
              console.log('error updating profile', err)
            }
          } else {
            let specificProfile = this.profiles.find(profile => profile.name === 'Byggeri')
            if (specificProfile) {
              try {
                await this.setProfile(specificProfile.profileId)
                let projectObject = {
                  profileId: specificProfile.profileId,
                  contentJson: {
                    name: this.projectName,
                    customer: this.projectCustomer,
                    responsible: this.projectResponsible,
                    description: this.projectDescription,
                    comment: '',
                    phases: []
                  }
                }
                this.setNewProject(projectObject)
                this.closeModal()
                this.setActivePageCode('goals')
              } catch (err) {
                console.log('error getting profile from server', err)
              }
            } else {
              console.log('Could not find profile')
            }
          }
        }
      }
    },
    closeModal () {
      this.setShowModal(false)
      this.setModalType(null)
      this.setModalData(null)
    }
  },
  mounted () {
    if (this.data) {
      this.tempProjectName = this.projectName
    }
    this.$refs.projectName.focus()
  }
}
</script>
